// Default "Ventajas del Socio" comparison matrix. Shared between the public
// page (fallback when settings.benefits_data is empty) and the CMS editor
// (loaded as starting point when the editor has no data yet).
export const DEFAULT_BENEFITS = {
  tiers: [
    { key: "basico",   name_es: "Socio Básico",   name_fr: "Membre Basique",  price: "5.000 Dhs",  featured: false },
    { key: "standard", name_es: "Socio Standard", name_fr: "Membre Standard", price: "25.000 Dhs", featured: true  },
    { key: "premium",  name_es: "Socio Premium",  name_fr: "Membre Premium",  price: "50.000 Dhs", featured: false },
  ],
  categories: [
    {
      key: "networking", label_es: "Networking", label_fr: "Networking",
      rows: [
        {
          label_es: "Participación gratuita en encuentros, misiones comerciales, etc.",
          label_fr: "Participation gratuite aux rencontres, missions commerciales, etc.",
          cells: [{ type: "yes" }, { type: "yes" }, { type: "yes" }],
        },
        {
          label_es: "Prospección comercial (Agenda de contactos)",
          label_fr: "Prospection commerciale (Agenda de contacts)",
          cells: [
            { type: "text", es: "1/año",       fr: "1/an" },
            { type: "text", es: "1/semestre",  fr: "1/semestre" },
            { type: "text", es: "1/trimestre", fr: "1/trimestre" },
          ],
        },
        {
          label_es: "Desarrollo de sus oportunidades de negocio",
          label_fr: "Développement de vos opportunités d'affaires",
          cells: [{ type: "yes" }, { type: "yes" }, { type: "yes" }],
        },
        {
          label_es: "Creación de una nueva red de contactos profesionales",
          label_fr: "Création d'un nouveau réseau de contacts professionnels",
          cells: [{ type: "yes" }, { type: "yes" }, { type: "yes" }],
        },
      ],
    },
    {
      key: "marketing", label_es: "Promoción y Marketing", label_fr: "Promotion et Marketing",
      rows: [
        {
          label_es: "Evento personalizado de networking — Desayuno debate, Afterwork, etc.",
          label_fr: "Événement personnalisé de networking — Petit-déjeuner débat, Afterwork, etc.",
          cells: [{ type: "no" }, { type: "text", es: "1/año", fr: "1/an" }, { type: "text", es: "2/año", fr: "2/an" }],
        },
        { label_es: "Difusión de contactos comerciales", label_fr: "Diffusion de contacts commerciaux",
          cells: [{ type: "yes" }, { type: "no" }, { type: "yes" }] },
        { label_es: "Rollup corporativo en los eventos de la Cámara", label_fr: "Roll-up corporatif lors des événements de la Chambre",
          cells: [{ type: "no" }, { type: "no" }, { type: "yes" }] },
        { label_es: "Añadir su logotipo en el pie de página de nuestra correspondencia",
          label_fr: "Intégration de votre logo dans le pied de page de notre correspondance",
          cells: [{ type: "no" }, { type: "yes" }, { type: "yes" }] },
        { label_es: "Añadir su logotipo en los principales eventos de la Cámara",
          label_fr: "Intégration de votre logo dans les principaux événements de la Chambre",
          cells: [{ type: "no" }, { type: "yes" }, { type: "yes" }] },
        { label_es: "Distribución de material corporativo en los eventos de la Cámara",
          label_fr: "Distribution de matériel corporatif lors des événements de la Chambre",
          cells: [{ type: "no" }, { type: "no" }, { type: "yes" }] },
        { label_es: "Mailing promocional", label_fr: "Mailing promotionnel",
          cells: [{ type: "no" }, { type: "text", es: "1/semestre", fr: "1/semestre" }, { type: "text", es: "1/trimestre", fr: "1/trimestre" }] },
      ],
    },
    {
      key: "anuario", label_es: "Anuario del Socio", label_fr: "Annuaire du Membre",
      rows: [
        { label_es: "Difusión de sus datos en el anuario", label_fr: "Diffusion de vos données dans l'annuaire",
          cells: [{ type: "yes" }, { type: "yes" }, { type: "yes" }] },
        { label_es: "Incluir su logotipo en el anuario", label_fr: "Inclusion de votre logo dans l'annuaire",
          cells: [{ type: "no" }, { type: "yes" }, { type: "yes" }] },
        { label_es: "Inserción publicitaria en el anuario", label_fr: "Insertion publicitaire dans l'annuaire",
          cells: [{ type: "no" }, { type: "no" }, { type: "yes" }] },
      ],
    },
    {
      key: "web", label_es: "Página web CECIT", label_fr: "Site web CECIT",
      rows: [
        { label_es: "Difusión de sus datos", label_fr: "Diffusion de vos données",
          cells: [{ type: "yes" }, { type: "yes" }, { type: "yes" }] },
        { label_es: "Añadir su logotipo con enlace a su página web", label_fr: "Ajout de votre logo avec lien vers votre site web",
          cells: [{ type: "no" }, { type: "yes" }, { type: "yes" }] },
        { label_es: "Formar parte del banner central de bienvenida de la web", label_fr: "Présence dans le bandeau central d'accueil du site",
          cells: [{ type: "no" }, { type: "no" }, { type: "yes" }] },
        { label_es: "Video corporativo en la web", label_fr: "Vidéo corporative sur le site",
          cells: [{ type: "no" }, { type: "no" }, { type: "yes" }] },
        { label_es: "Publicación de noticias y/o eventos de su empresa", label_fr: "Publication de nouvelles et/ou événements de votre entreprise",
          cells: [{ type: "no" }, { type: "text", es: "1/mes", fr: "1/mois" }, { type: "text", es: "1/mes", fr: "1/mois" }] },
      ],
    },
    {
      key: "social", label_es: "Redes Sociales", label_fr: "Réseaux Sociaux",
      rows: [
        { label_es: "Publicación de promociones / publicidad en redes sociales",
          label_fr: "Publication de promotions / publicité sur les réseaux sociaux",
          cells: [{ type: "no" }, { type: "text", es: "1/trimestre", fr: "1/trimestre" }, { type: "text", es: "1/mes", fr: "1/mois" }] },
        { label_es: "Publirreportaje de su empresa en redes sociales y newsletter",
          label_fr: "Publireportage de votre entreprise sur les réseaux sociaux et newsletter",
          cells: [{ type: "no" }, { type: "no" }, { type: "yes" }] },
      ],
    },
    {
      key: "extra", label_es: "Otros beneficios", label_fr: "Autres avantages",
      rows: [
        { label_es: "Asesoramiento y acompañamiento", label_fr: "Conseil et accompagnement",
          cells: [{ type: "yes" }, { type: "yes" }, { type: "yes" }] },
        { label_es: "Descuentos en hoteles", label_fr: "Réductions dans les hôtels",
          cells: [{ type: "yes" }, { type: "yes" }, { type: "yes" }] },
        { label_es: "Apoyo para las solicitudes de visado de negocios", label_fr: "Assistance pour les demandes de visa d'affaires",
          cells: [
            { type: "text", es: "Según categoría", fr: "Selon catégorie" },
            { type: "text", es: "Según categoría", fr: "Selon catégorie" },
            { type: "text", es: "Según categoría", fr: "Selon catégorie" },
          ] },
        { label_es: "Descuentos en formación presencial y online", label_fr: "Réductions sur les formations présentielles et en ligne",
          cells: [{ type: "yes" }, { type: "yes" }, { type: "yes" }] },
      ],
    },
  ],
};
